
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"41","height":"41"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#268C3D","fill-rule":"evenodd","d":"M20.5 0C9.178 0 0 9.178 0 20.5S9.178 41 20.5 41 41 31.822 41 20.5 31.822 0 20.5 0zm10.301 16.615c.011.205.011.421.011.636 0 6.529-4.972 14.063-14.063 14.063a13.77 13.77 0 01-7.555-2.235 9.93 9.93 0 007.319-2.04 4.935 4.935 0 01-4.613-3.433c.308.061.615.092.933.092a4.96 4.96 0 001.302-.174 4.949 4.949 0 01-3.967-4.849v-.061a4.849 4.849 0 002.234.615 4.92 4.92 0 01-2.203-4.11c0-.902.246-1.753.666-2.481a14.022 14.022 0 0010.189 5.166 4.49 4.49 0 01-.134-1.127 4.943 4.943 0 014.941-4.941 4.92 4.92 0 013.608 1.558 9.99 9.99 0 003.136-1.199 4.941 4.941 0 01-2.173 2.737 10.038 10.038 0 002.839-.779 10.114 10.114 0 01-2.47 2.562z"}})])
          )
        }
      }
    